<template>
  <CCard>
    <CCardHeader class="p-2 font-weight-bold" style="line-height: 2">
      실시간 포화수증기량
    </CCardHeader>
    <CCardBody class="p-2" v-if="emptyFlag"> 데이터 없음</CCardBody>
    <CCardBody class="p-2" :class="emptyFlag ? 'd-none' : ''">
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead>
          <tr>
            <th>T ℃</th>
            <th>measured</th>
            <th>calculated</th>
            <th>error</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>0</td>
            <td>4.85</td>
            <td>4.82</td>
            <td>0.03</td>
          </tr>
          <tr>
            <td>5</td>
            <td>6.80</td>
            <td>6.85</td>
            <td>-0.05</td>
          </tr>
          <tr>
            <td>10</td>
            <td>9.40</td>
            <td>9.43</td>
            <td>-0.03</td>
          </tr>
          <tr>
            <td>11</td>
            <td>10.01</td>
            <td>10.03</td>
            <td>-0.02</td>
          </tr>
          <tr>
            <td>12</td>
            <td>10.66</td>
            <td>10.67</td>
            <td>-0.01</td>
          </tr>
          <tr>
            <td>13</td>
            <td>11.35</td>
            <td>11.35</td>
            <td>0.0</td>
          </tr>
          <tr>
            <td>14</td>
            <td>12.07</td>
            <td>12.06</td>
            <td>0.01</td>
          </tr>
          <tr>
            <td>15</td>
            <td>12.83</td>
            <td>12.82</td>
            <td>0.01</td>
          </tr>
          <tr>
            <td>20</td>
            <td>17.30</td>
            <td>17.28</td>
            <td>0.02</td>
          </tr>
          <tr>
            <td>25</td>
            <td>23.00</td>
            <td>23.10</td>
            <td>-0.10</td>
          </tr>
          <tr>
            <td>30</td>
            <td>30.40</td>
            <td>30.55</td>
            <td>-0.15</td>
          </tr>
          <tr>
            <td>37</td>
            <td>44.00</td>
            <td>44.22</td>
            <td>-0.20</td>
          </tr>
          <tr>
            <td>40</td>
            <td>51.10</td>
            <td>51.37</td>
            <td>-0.27</td>
          </tr>
          </tbody>
        </table>

      </div>
    </CCardBody>
  </CCard>
</template>

<script>
import store from "@/store";
import MixinsInEnvSensor from "@/mixins/in-env-sensor";

export default {
  name: "RealTimeSaturatedWaterVaporComponent",
  components: {},
  mixins: [MixinsInEnvSensor()],
  props: {
    properties: {
      type: Object,
      default: () => {
        return {
          initFlag: false,
          inEnvList: [],
        };
      },
    },
  },
  data() {
    return {
      app: store.state.app,
      emptyFlag: true,
    };
  },
  mounted() {
    this.init();
    this.emptyFlag = false;
  },
  watch: {
    "properties.initFlag"(val) {
      this.properties.initFlag = false;
      if (val) {
        this.init();
      }
    },
    "properties.inEnvList"() {
      this.redraw();
    },
  },
  methods: {
    init() {},
    redraw() {},
  },
};
</script>
